<template>
  <span v-if="workingQualifier">
      <v-row class="mt-8">
          <v-col cols="12">
            <v-text-field
              label="Minimum Transaction Count"
              v-model="workingQualifier.minimumTransactionCount"
              type="number"
              hint="Ex. 2"
              hide-spin-buttons
              dense
              :rules="requiredAndPositiveRule"
              @input="onChange"
              name="minimumTransactionCount"
            />
          </v-col>
        </v-row>
        <v-row class="mt-6">
          <v-col cols="12">
            <v-text-field
              label="Minimum Transaction Amount"
              v-model="workingQualifier.minimumTransactionAmount"
              type="number"
              hint="Ex. 5.00"
              prefix="$"
              hide-spin-buttons
              dense
              :rules="requiredAndPositiveRule"
              @input="onChange"
              name="minimumTransactionAmount"
            />
          </v-col>
        </v-row>
        <v-row class="mt-6">
          <v-col cols="12">
            <v-radio-group
              label="POS Transaction Type"
              v-model="workingQualifier.transactionType"
              dense
              :rules="requiredRule"
              @change="onChange">
              <v-radio v-for="item in Object.entries(DebitPosTransactionTypes)" v-bind:key="item.value" :value="item[1].value" :label="item[1].description" :ref="`${item[1].value}_Radio`"/>
            </v-radio-group>
          </v-col>
        </v-row>
    </span>
</template>

<script lang="ts">
import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { PosQualifier } from '@/api/product/levelrewards/qualifiers';
import { DebitPosTransactionTypes } from '@/api/product/levelrewards';
import ValidationTool from '@/util/ValidationTool';

@Component
export default class PosQualifierEditor extends Vue {
  @Prop()
  value!:PosQualifier;

  workingQualifier:PosQualifier | null = null;

  // Make visible to template
  DebitPosTransactionTypes:any = DebitPosTransactionTypes;

  requiredRule:Array<any> = [(value: any) => {
    if (value === null || value === undefined || (Array.isArray(value) && value.length === 0)) {
      return 'Required';
    }
    return true;
  }];

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  mounted() {
    this.initialize();
  }

  @Watch('value')
  initialize() {
    this.workingQualifier = this.value.clone() as PosQualifier;
  }

  onChange() {
    this.$emit('input', this.workingQualifier);
  }
}
</script>

<style lang="scss" scoped>
</style>
